/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Util} from "../Utilities.js";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import ElementStatus from "./ElementStatus.jsx";
import DisplayStateHistory from "./DisplayStateHistory.jsx";
import {Nodes} from "../Objects/Nodes.jsx";

class NodeManagement extends Component {
    constructor() {
        super();
        this.state = {
            allNodes: []
        }
    }


    async fetchData() {
        let allNodes = await Nodes().listAll()
        this.setState({allNodes: allNodes?.recordset || allNodes || []})
    }

    componentDidMount() {
        this.fetchData()
    }


    async editCertificate(node) {


        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2"}>
                <OutputList>
                    <OutputListItem titel={"Name"}>
                        <span>{node.Name}</span>
                    </OutputListItem>
                    <OutputListItem titel={"nodeDomain"}>
                        <span>{node.nodeDomain}</span>
                    </OutputListItem>
                    <OutputListItem titel={"nodeIP"}>
                        <span>{node.nodeIP}</span>
                    </OutputListItem>
                    <OutputListItem titel={"nodeIPv4"}>
                        <span>{node.nodeIPv4}</span>
                    </OutputListItem>
                    <OutputListItem titel={"serverId"}>
                        <span>{node.serverId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Action"}>
                        <ButtonComponent
                            text={"Remove Node"}
                            onClick={async () => {
                                await Nodes(node.indexKey).remove()
                                await this.fetchData()
                                close()
                            }}></ButtonComponent>


                    </OutputListItem>
                    <OutputListItem titel={"Action"}>
                        <ButtonComponent
                            text={"Edit Node"}
                            onClick={async () => {
                                UI.page().navigate({
                                    pathname: "/n/" + node.indexKey
                                })
                                close()
                            }}></ButtonComponent>


                    </OutputListItem>

                    {/*<OutputListItem titel={"Is Expired"}>*/}
                    {/*    <span>{status.isExpired ? <span className={"text-red-600"}> Is Expired</span> :*/}
                    {/*        <span className={"text-green-600"}>Is valid</span>}</span>*/}
                    {/*</OutputListItem>*/}
                    {/*<OutputListItem titel={"Private key match"}>*/}
                    {/*    <span>{status.privateKeyCorrect ? <span className={"text-green-600"}>Key matches </span> :*/}
                    {/*        <span className={"text-red-600"}>Key does not match </span>}</span>*/}
                    {/*</OutputListItem>*/}
                    {/*<OutputListItem titel={"Private key match"}>*/}
                    {/*    <span>{status.coversDomain ? <span className={"text-green-600"}>Domain covered  </span> :*/}
                    {/*        <span*/}
                    {/*            className={"text-red-600"}>The domain name is not convert by this Certificate  </span>}</span>*/}
                    {/*</OutputListItem>*/}
                    <DisplayStateHistory name={"Nodes"} elementId={node.indexKey}/>

                </OutputList>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Certificate", button: [{
                type: "save", text: "Create Token", onClick: async (state, setState, close) => {

                    await this.fetchData()
                    close()
                }
            }, {
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allNodes} = this.state
        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Node"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Nodes"} elementId={row.indexKey}/>

                            {row?.URL !== undefined && (<>
                                <IconButtonComponent text={`Open`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         let url = "/a/" + row.URL.replace(/^\//g, '')
                                                         // open the page
                                                         UI.page().navigate({
                                                             pathname: url,
                                                         })
                                                     }}/>
                            </>)}

                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allNodes.map(item => ({
                        ...item,
                        Name: item.nodeName

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editCertificate(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default NodeManagement;